import { render, staticRenderFns } from "./MdinAddMain.vue?vue&type=template&id=f5fd736e&scoped=true&"
import script from "./MdinAddMain.vue?vue&type=script&lang=js&"
export * from "./MdinAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MdinAddMain.vue?vue&type=style&index=0&id=f5fd736e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fd736e",
  null
  
)

export default component.exports